class PredictiveSearch extends HTMLElement {
    constructor() {
      super();
  
      this.input = this.querySelector('input[type="search"]');
      this.form = this.querySelector('form');
      this.predictiveSearchResults = this.querySelector('#predictive-search');
  
      this.input.addEventListener('input', this.debounce((event) => {
        this.onChange(event);
      }, 300).bind(this));

      this.input.addEventListener('keydown', (e) => this.handleKeydown(e));
      this.form.addEventListener('submit', (e) => e.preventDefault());
    }

    handleKeydown(event) {
      if (event.key === 'Enter') {
        event.preventDefault();
        event.stopPropagation();
      }
    }

    onChange() {
      const searchTerm = this.input.value.trim();
  
      if (!searchTerm.length) {
        this.close();
        return;
      }
  
      this.getSearchResults(searchTerm);
    }


    updateProductCount() {
        let productCount = document.querySelectorAll(".predictive-search-products .card-product-main").length;
        document.querySelector(".listtext .cout").textContent = productCount;

        if(document.querySelector(".listtext .cout").textContent == '0'){
            document.querySelector('.suggestions-carousel .swiper-productsr__').style.display = 'block';
        }else{
            document.querySelector('.suggestions-carousel .swiper-productsr__').style.display = 'none';   
        }
    }


  
    getSearchResults(searchTerm) {
      fetch(`/search/suggest?q=${searchTerm}&section_id=predictive-search`)
        .then((response) => {
          if (!response.ok) {
            var error = new Error(response.status);
            this.close();
            throw error;
          }
          return response.text();
        })
        .then((text) => {
          const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
          this.predictiveSearchResults.innerHTML = resultsMarkup;
          this.open();

          initButtons();
          initGrid();
          setupButtons(document.querySelectorAll('#predictive-search-results .wishlist-btn'));
       
          this.updateProductCount();
        })
        .catch((error) => {
          this.close();
          throw error;
        });

       
    }
  
    open() {
      this.predictiveSearchResults.style.display = 'block';
    }
  
    close() {
      this.predictiveSearchResults.style.display = 'none';
    }
  
    debounce(fn, wait) {
      let t;
      return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
      };
    }
  }
  
customElements.define('predictive-search', PredictiveSearch);
  



document.addEventListener("DOMContentLoaded", function () {
    const searchInput = document.getElementById("searchInput");
    const inputValueDiv = document.querySelector(".inputvalue");
    const listText = document.querySelector(".listtext");
    searchInput.addEventListener("input", function () {
        inputValueDiv.textContent = searchInput.value;

        if (searchInput.value.trim() !== "") {
            listText.style.display = "block";
        } else {
            listText.style.display = "none";
        }
    });
});



